/**
 * Calcula la posición del botón según el cuadrante especificado
 * Los cuadrantes se dividen en una grilla de 2 columnas x 4 filas (8 cuadrantes totales)
 * 
 * Cuadrante 1: top-left
 * Cuadrante 2: top-right
 * Cuadrante 3: second-row-left
 * Cuadrante 4: second-row-right
 * Cuadrante 5: third-row-left
 * Cuadrante 6: third-row-right
 * Cuadrante 7: bottom-left
 * Cuadrante 8: bottom-right
 */

export interface ButtonPosition {
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
  transform?: string;
}

export interface GetButtonPositionOptions {
  /** Margen izquierdo para cuadrantes impares (ej. "32px"). Si se pasa, se usa en lugar de 10%. */
  leftMargin?: string;
}

export const getButtonPosition = (
  posicionBoton: string,
  options?: GetButtonPositionOptions
): ButtonPosition => {
  // Extraer el número del cuadrante (ej: "cuadrante 1" -> 1)
  const match = posicionBoton.match(/\d+/);
  if (!match) {
    // Por defecto, centrar el botón
    return {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    };
  }

  const cuadrante = parseInt(match[0], 10);

  // Grilla de 2 columnas x 4 filas
  // Columna 1 (left): cuadrantes impares (1, 3, 5, 7)
  // Columna 2 (right): cuadrantes pares (2, 4, 6, 8)
  const isLeft = cuadrante % 2 === 1;
  const row = Math.ceil(cuadrante / 2);

  // Distribución más alta en la grilla para evitar solapar el pager del carrusel (filas 7 y 8)
  const topPercent = (row - 1) * 22 + 8;
  // Cuadrantes impares: usar leftMargin si se proporciona (mismo margen que el texto), si no 10%
  const horizontalPositionLeft = options?.leftMargin ?? '10%';
  const horizontalPositionRight = '10%';

  return {
    top: `${topPercent}%`,
    left: isLeft ? horizontalPositionLeft : undefined,
    right: !isLeft ? horizontalPositionRight : undefined,
    transform: 'translateY(-50%)'
  };
};


